<template>
  <div>
    <v-text-field
      v-model="value.title"
      :label="$t('instructions.title')"
      data-cy="instructionTitle"
    ></v-text-field>
  </div>
</template>
<script>
export default {
  props: ["value"],
};
</script>
